// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__378OR","col":"CardReaderDesc_col__3t_xg","label":"CardReaderDesc_label__1h3i6"};